import { Button } from 'slab'

import { useOnboarding } from '../OnboardingContext'
import { type StepComponentProps } from '../types'

export const SubsidyEligiblePage = ({
  navigateToSpecificStep,
  navigateToPreviousStep,
  navigateToNextStep,
}: StepComponentProps) => {
  const { onboardingData } = useOnboarding()

  return (
    <div data-testid='SubsidyEligiblePage' className='max-w-[44rem]'>
      <h2 className='heading-md mb-6 text-gray-800'>
        You might be able to get cheaper insurance elsewhere
      </h2>
      <div className='mb-10'>
        <p className='body mb-3 text-gray-800'>
          We think you're eligible for lower insurance costs through the federal
          or state marketplace, which offers tax credits and subsidies based on
          reported household income. In most cases, taking advantage of these
          subsidies will be cheaper than what you can find through us.
        </p>
        <p className='body text-gray-800'>
          It's up to you whether you'd prefer to get a subsidy or your
          employer's allowance, but unfortunately you can't use both at the same
          time.
        </p>
      </div>
      <div className='flex justify-between'>
        <Button
          size='large'
          variant='tertiary-deemphasized'
          onClick={() => navigateToPreviousStep?.(onboardingData)}
        >
          Back
        </Button>
        <div className='flex gap-x-4'>
          <Button
            size='large'
            variant='secondary'
            onClick={() => navigateToNextStep(onboardingData)}
          >
            I'd rather use my allowance
          </Button>
          <Button
            size='large'
            variant='primary'
            onClick={() => {
              navigateToSpecificStep?.('opted_out_from_subsidy_eligible')
            }}
          >
            I'll get a subsidized plan
          </Button>
        </div>
      </div>
    </div>
  )
}
